import { colorCss } from "./colorCss";

const RGBA_FLOATS = 4;

/**
 * Canvas 2D version of rectRenderer.draw: the same snapping to whole device
 * pixels as its vertex shader (x only when isSnappedX), filled colour slot by colour slot.
 *
 * @param {CanvasRenderingContext2D} context
 * @param {Float32Array} instances - [x, y0, y1, shape slot, colour slot] per rectangle
 * @param {number} floatsPerInstance
 * @param {object} params - see rectRenderer.draw
 */
export const paintRects = (
  context,
  instances,
  floatsPerInstance,
  { viewport, xTransform, yTransform, shapes, palette, isSnappedX = true },
) => {
  const [xScale, xOffset] = xTransform;
  const [yScale, yOffset] = yTransform;
  const [viewWidth] = viewport;
  const { widths, offsets, minHeight } = shapes;
  const usedSlots = new Set();

  for (let offset = 0; offset < instances.length; offset += floatsPerInstance) {
    usedSlots.add(instances[offset + 4]);
  }

  usedSlots.forEach((slot) => {
    context.fillStyle = colorCss(palette, slot * RGBA_FLOATS);

    for (let offset = 0; offset < instances.length; offset += floatsPerInstance) {
      if (instances[offset + 4] !== slot) continue;

      const shape = instances[offset + 3];
      const width = widths[shape];
      const xDevice = instances[offset] * xScale + xOffset;
      const left = (isSnappedX ? Math.floor(xDevice) : xDevice) + offsets[shape];

      if (left + width < 0 || left > viewWidth) continue;

      const yFirst = Math.floor(instances[offset + 1] * yScale + yOffset + 0.5);
      const ySecond = Math.floor(instances[offset + 2] * yScale + yOffset + 0.5);
      const height = Math.max(Math.abs(ySecond - yFirst), minHeight);
      const top = Math.floor((yFirst + ySecond - height) * 0.5);

      context.fillRect(left, top, width, height);
    }
  });
};
